import { WizardStepsController } from './wizard-steps.controller';
import { WizardStepsComponentProps } from './wizard-steps.model';

const WizardSteps = (props: WizardStepsComponentProps): JSX.Element => {
  return <WizardStepsController {...props} />;
};
export default WizardSteps;
